import type { Appearance } from "@clerk/types";

/** Estilos extra para `<SignUp />` / `<SignIn />` embebidos (el logo global está en `ClerkProvider`). */
export function getRegistroClerkAppearance(): Appearance {
  return {
    elements: {
      rootBox: "w-full mx-auto",
      card: "bg-transparent shadow-none border-0 p-0 gap-4",
      cardBox: "!shadow-none bg-transparent border-0 p-0",
      headerTitle: "text-zinc-100",
      headerSubtitle: "text-zinc-400",
      footer: "text-zinc-500",
      // Glass inputs
      formFieldInput:
        "bg-white/[0.04] border border-white/10 text-zinc-100 rounded-xl backdrop-blur transition-colors focus:border-amber-400/50 focus:ring-2 focus:ring-amber-400/20",
      formFieldLabel: "text-zinc-300",
      // Primary CTA
      formButtonPrimary:
        "bg-amber-500 hover:bg-amber-400 text-zinc-950 font-semibold rounded-xl shadow-lg shadow-amber-500/20 transition-colors normal-case",
      // Social / secondary buttons as glass
      socialButtonsBlockButton:
        "bg-white/[0.04] border border-white/10 text-zinc-100 rounded-xl backdrop-blur hover:bg-white/[0.08] transition-colors",
      socialButtonsBlockButtonText: "text-zinc-100",
      dividerLine: "bg-white/10",
      dividerText: "text-zinc-500",
      formFieldInputShowPasswordButton: "text-zinc-400 hover:text-zinc-200",
      footerActionLink: "text-amber-300 hover:text-amber-200",
      otpCodeFieldInput: "bg-white/[0.04] border border-white/10 text-zinc-100 rounded-xl",
    },
    variables: {
      colorPrimary: "hsl(var(--primary))",
      colorBackground: "transparent",
      colorText: "hsl(240, 5%, 95%)",
      colorTextSecondary: "hsl(240, 5%, 65%)",
      colorInputBackground: "rgba(255, 255, 255, 0.04)",
      colorInputText: "hsl(240, 5%, 95%)",
      colorNeutral: "hsl(240, 5%, 95%)",
      borderRadius: "0.75rem",
      spacingUnit: "0.95rem",
    },
  };
}
